import { __assign, __read, __spread } from "tslib";
import React, { Fragment, useState } from "react";
import classNames from "classnames";
import { Popover } from "../popover";
import { Input } from "../input";
import { Icon } from "../icon";
import { Text } from "../text";
import { CascaderBox, getOptions } from "./CascaderBox";
import { CascaderMenuBox } from "./CascadeMenu";
import { CascaderSearch } from "./CascaderSearch";
import { useDefaultValue } from "../form";
import { useTranslation } from "../i18n";
import { useDefault } from "../_util/use-default";
import { useConfig } from "../_util/config-context";
import { noop } from "../_util/noop";
import { mergeEventProps } from "../_util/merge-event-props";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
var defaultValueRender = function (options) {
    return options.map(function (_a, index) {
        var label = _a.label, value = _a.value;
        return (React.createElement(Fragment, { key: value + "-" + index },
            index !== 0 && " / ",
            label || value));
    });
};
export var CascaderSingle = forwardRefWithStatics(function CascaderSingle(props, ref) {
    var _a;
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    var _b = useDefaultValue(props, []), data = _b.data, value = _b.value, onChange = _b.onChange, onLoad = _b.onLoad, disabled = _b.disabled, changeOnSelect = _b.changeOnSelect, style = _b.style, className = _b.className, _c = _b.placeholder, placeholder = _c === void 0 ? t.pleaseSelect : _c, _d = _b.defaultOpen, defaultOpen = _d === void 0 ? false : _d, open = _b.open, _e = _b.onOpenChange, onOpenChange = _e === void 0 ? noop : _e, _f = _b.placement, placement = _f === void 0 ? "bottom-start" : _f, _g = _b.placementOffset, placementOffset = _g === void 0 ? 5 : _g, _h = _b.closeOnScroll, closeOnScroll = _h === void 0 ? true : _h, escapeWithReference = _b.escapeWithReference, popupContainer = _b.popupContainer, overlayClassName = _b.overlayClassName, overlayStyle = _b.overlayStyle, clearable = _b.clearable, searchable = _b.searchable, filter = _b.filter, type = _b.type, expandTrigger = _b.expandTrigger, _j = _b.valueRender, valueRender = _j === void 0 ? defaultValueRender : _j, tips = _b.tips, bottomTips = _b.bottomTips, _k = _b.onScrollBottom, onScrollBottom = _k === void 0 ? noop : _k, _l = _b.onSearch, onSearch = _l === void 0 ? noop : _l;
    var _m = __read(useState(false), 2), hover = _m[0], setHover = _m[1];
    var _o = __read(useDefault(open, defaultOpen, onOpenChange), 2), isOpened = _o[0], setIsOpened = _o[1];
    var _p = __read(useState(false), 2), focused = _p[0], setFocused = _p[1];
    var _q = __read(useState(false), 2), searching = _q[0], setSearching = _q[1];
    var _r = __read(useState(""), 2), searchValue = _r[0], setSearchValue = _r[1];
    var options = getOptions(data, value);
    var Box = type === "menu" ? CascaderMenuBox : CascaderBox;
    return (React.createElement(Popover, { trigger: disabled ? "empty" : "click", visible: isOpened, onVisibleChange: setIsOpened, onExited: function () {
            setSearchValue("");
            setSearching(false);
        }, placement: placement || "bottom-start", placementOffset: placementOffset, closeOnScroll: closeOnScroll, escapeWithReference: escapeWithReference, popupContainer: popupContainer, overlayClassName: overlayClassName, overlayStyle: overlayStyle, overlay: function (_a) {
            var scheduleUpdate = _a.scheduleUpdate;
            if (searchValue) {
                return (React.createElement(CascaderSearch, { data: data, searchValue: searchValue, filter: filter, onChange: function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        onChange.apply(void 0, __spread(args));
                        setIsOpened(false);
                        setSearching(false);
                    }, scheduleUpdate: scheduleUpdate, changeOnSelect: changeOnSelect, tips: tips, bottomTips: bottomTips, onScrollBottom: onScrollBottom }));
            }
            return (React.createElement(Box, { data: data, curValue: value, onLoad: onLoad, onSelect: onChange, onClose: function () { return setIsOpened(false); }, changeOnSelect: changeOnSelect, scheduleUpdate: scheduleUpdate, expandTrigger: expandTrigger, tips: tips, bottomTips: bottomTips, onScrollBottom: onScrollBottom }));
        } },
        React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-cascader", className, (_a = {},
                _a[classPrefix + "-cascader--search"] = searchable,
                _a["is-disabled"] = disabled,
                _a)), style: style }, mergeEventProps(props, {
            onMouseEnter: function () { return setHover(true); },
            onMouseLeave: function () { return setHover(false); },
        })),
            React.createElement("div", { className: classPrefix + "-cascader__input" },
                !searching && (React.createElement("div", { className: classPrefix + "-cascader__value" },
                    React.createElement(Text, { theme: focused ? "weak" : undefined }, valueRender(options)))),
                React.createElement(Input, { readonly: !searchable, autoComplete: "off", disabled: disabled, placeholder: value.length ? "" : placeholder, value: searching ? searchValue : "", onFocus: function () {
                        if (searchable) {
                            setFocused(true);
                            setIsOpened(true);
                            if (searchValue) {
                                setSearching(true);
                            }
                        }
                    }, onBlur: function () {
                        setFocused(false);
                        setSearching(false);
                    }, onChange: function (value) {
                        setSearchValue(value);
                        onSearch(value);
                    }, onInput: function (event) {
                        setSearching(!!event.currentTarget.value);
                    }, onClick: function (event) { return searchable && event.stopPropagation(); } })),
            clearable && !disabled && hover && value.length ? (React.createElement(Icon, { type: "dismiss", onClick: function (event) {
                    event.stopPropagation();
                    onChange([], { event: event, options: [] });
                    setIsOpened(false);
                } })) : (React.createElement(Icon, { type: "arrowdown" })))));
}, {
    defaultLabelAlign: "middle",
});
CascaderSingle.displayName = "CascaderSingle";
//# sourceMappingURL=CascaderSingle.js.map